<template>
	<div class="page">

		<!-- page header -->
		<div class="page-header" :class="this.showPageHeader ? 'scroll show' : 'scroll hide'">

			<div style=""
				:class="this.isAnyPageMenuVisible() ? 'page-header-menu page-header-menu-show' : 'page-header-menu page-header-menu-hide'">
				<div class="center  center-padding page-header-menu" @click.self="this.hidePopovers()" style="">

					<!-- innehåll page meny top -->
					<div class="flexcenter" style="width:100%;align-items: baseline;gap:10px;" @click.self="this.hidePopovers()">


						<div class="flexcenter link" style="padding:5px;padding-left:0px;border-radius:5px;"
							@click="this.showSideMenuCategory()">
							<b>Kategorier </b>
							<Icon fileName="w3_chevron_right_dark" style="height:10px;width:7px;margin-left:1px;" />
						</div>

						<div class="flexcenter link desktop" style="padding:5px;padding-left:0px;border-radius:5px;"
							@click="this.togglePageMenu('menuCategory')">
							<b>Kategorier</b>
						</div>

						<div class="flexcenter link" style="padding:5px;border-radius:5px;"
							@click="this.togglePageMenu('menuManufactor')">
							<b>Varumärken</b>
						</div>

						<div class="flexcenter link" style="padding:5px;border-radius:5px;" @click="this.togglePageMenu('menuMV')">
							<b>Modellväljaren</b>
						</div>

						<div v-if="this.debug" class="flexcenter link"
							style="background:var(--grey-4);padding:5px;border-radius:5px;" @click="getProductRowList()">
							<b>Hämta</b>
							<Icon v-if="this.productSpinner" fileName="w3_spinner_dark" class="spinner"
								style="width:20px;height:20px;margin-left:5px;" />
						</div>


						<div v-if="this.debug">
							<input type="checkbox" v-model="autoSearch" title="Autosök (tryck enter för att söka annars)" />Autosök
						</div>

						<div style=" flex-grow:1;background:transparent;height:20px;" @click="this.hideAllPageMenu()">&nbsp;
						</div>
						<div v-if="this.debug" @click="this.togglePageMenu('menuSearch')" class="link flexcenter">
							<b>Visa menu A </b>
							<Icon fileName="button_down_dark" style="width:20px;height:20px;margin-left:5px;" />
						</div>



					</div>


					<SearchProductTextfield v-if="this" @click="this.productSearchEnabled && (this.showPageMenu('menuSearch'));"
						@enterPressed="this.handleEnterPressed(); " @closeProductSearchPopover="(() => this.hideAllPageMenu())"
						@showProductSearchPopover="this.showProductSerachPopover()" v-model:filterInput="this.filterInput"
						:spinning="this.searchProductTextfieldSpinning" />

					<!-- @filterInputChanged="((filterInput) => this.filterInput = filterInput) -->


				</div>

			</div>




			<SearchPopoverView v-if="this" class="page-menu search-popover"
				:class="this.isPageMenuVisible('menuSearch') ? 'show' : 'hide'" :model="this.model"
				@click.self="this.hideAllPageMenu()"
				@showProductDetails="((product) => { this.showProductDetails(product); this.searchProductConfig.popoverOpen = true; })"
				@hideAllPageMenu="(() => this.hideAllPageMenu())" @closePopoverPressed="(() => this.hideAllPageMenu())"
				@searchManufactorSelected="((manufactor) => this.searchManufactorSelectedLocal(manufactor))"
				@searchCategorySelected="((category) => this.searchCategorySelectedLocal(category))"
				@searchMcSelected="((mc) => {this.searchMcSelected(mc); this.routerShowProductList() } )"
				@enterPressed="(() => this.enterPressed())" @resetScrollLimit="(() => this.resetScrollLimit())" />

			<!-- page menu done-->

			<!-- page menu open menu  modellväljaren -->
			<div class="page-menu page-menu-menu-mv" :class="this.isPageMenuVisible('menuMV') ? 'show' : 'hide'"
				@click.self="this.hideAllPageMenu()">

				<div v-if="!this" class="center-padding center" style="min-height:350px; ">


					<h3>Modellväljaren</h3><br />
					<div style="padding:0px;align-items: start;" class="flexcenter" title="Välj mc-märke och mc-modell">



						<select v-if="this.baseMcTree" v-model="this.searchProductConfig.brand" size="10" style="width:200px;">

							<option v-for="(brand) in this.baseMcTree" :key="brand.id" :value="brand">{{ brand.name }}</option>
						</select>

						<select v-if="this.baseMcTree" v-model="this.searchProductConfig.mc" size="10" style="width:300px;">

							<option v-for="mc in this.searchProductConfig.brand && this.searchProductConfig.brand.modelList"
								:key="mc.mcId" :value="mc">{{ mc.modelName }}
							</option>

						</select>

						<select v-if="this.baseMcTree" v-model="this.searchProductConfig.year" @change="yearSelectedMV();" size="10"
							style="width:100px;">

							<option
								v-for="year in this.searchProductConfig.mc && this.searchProductConfig.mc.yearList?.filter(year => year !== null).sort((a, b) => b.year - a.year)"
								:key="year.year" :value="year">{{
								year.year }}
							</option>

						</select>

					</div>


					<div>


						<Button label="OK" style="margin-top:10px;" @click="() => { this.hideAllPageMenu() }" />
					</div>
				</div>

				<div v-if="this" class="center-padding center" style="min-height:350px; ">
					<PopoverModelPicker @modelPickerComplete="(() => this.modelPickerComplete() )"
						@modelPickerCancel="(() => this.hideAllPageMenu())" />
				</div>
			</div>

			<!-- menu kategorier - popover med grid med kategorier -->
			<div class="page-menu page-menu-category" style=""
				:class="this.isPageMenuVisible('menuCategory') ? 'show' : 'hide'" @click.self="this.hideAllPageMenu()">

				<div class="center-padding center" style="min-height:350px;">

					{{this ? '' : this.visiblePageMenu }}


					<PopoverCategoryView @searchCategorySelected=" ((category)=> this.searchCategorySelected(category))" />
					<!-- @popoverCategoryClosed="(() => this.hideAllPageMenu())"-->
				</div>
			</div>

			<!-- menu manufactor - popover med grid med varumärken #MENUM -->
			<div class="page-menu page-menu-menu-manufactor"
				:class="this.isPageMenuVisible('menuManufactor') ? 'show' : 'hide'" @click.self="this.hideAllPageMenu()">

				<div v-if="this" class="center-padding center" style="min-height:350px;">
					<PopoverManufactorView
						@searchManufactorSelected="((manufactor) => this.searchManufactorSelectedLocal(manufactor))"
						@popoverManufactorClosed="(() => this.hideAllPageMenu())" :productTypeFilter="true" />
				</div>

			</div>
			<!-- page menu done-->

		</div>



		<!-- page-blur -->
		<div class="page-blur" :class="this.isAnyPageMenuVisible() ? 'blur-on' : 'blur-off'"
			@mouseenter="this.hideAllPageMenu()" @click="this.hideAllPageMenu()">
		</div>

		<!-- content -->
		<div :class="this.isAnyPageMenuVisible() ? 'menu-visible' : ''">


			<div style="background:var(--grey-bg);padding:0px;" class="box">
				<div class="center">
					<StartViewSpinner :show="this.showStartSpinner" /> <!-- this.showStartSpinner -->
				</div>

			</div>

			<div style="background:var(--grey-bg);min-height:300px; ">

				<SlideListWrapper class="center" />
			</div>

			<div style=" background:var(--grey-bg);padding:10px;padding-top:0px;">
				<div class="center flexcenter">
					<ProductTypeView @gotoStart="((section) => { this.$emit('gotoStart', section)})" />
				</div>
			</div>






			<!-- webcontent START_INTRO -->
			<div style="background:var(--grey-bg);padding:0px;">
				<div class="center center-padding" style="padding-top:20px;">

					<WebContent name="START_INTRO" :header="true" />

				</div>
			</div>

			<div style="background:var(--grey-bg);min-height:300px; ">
				<div class="center center-padding" style="padding-top:50px;">
					<h3>Produktkategorier</h3>

					<!-- kategorigrid med bilder -->
					<div id="startCategoryGrid" class="" style="">

						<div v-for="category in this.sortCategoryList(this.startCategoryGrid)" :key="category.categoryId"
							style="padding-bottom:10px;padding-left:0px;padding-right:0px;" class="link">


							<Card :cardtitle="category.name" @click="this.searchCategorySelectedLocal(category)"
								:filename="cateogryIdImageList.includes(category.categoryId) ? 'category_' + category.categoryId + '.jpg' : null"
								:title="'Visa produkter i kategori: ' + category.path + ', id: ' + category.categoryId" style=""
								:tint="true" mode="dark" fontSizeTitleMax="140%" class="card" />
						</div>
					</div>


				</div>

				<!-- välj mc-model -->
				<div
					id="modelpicker" style="">
					<div class="center center-padding"
						style="padding-top:50px;padding-bottom:100px;display:flex;justify-content: center;">
						<StartModelPicker :show="this.isPageMenuVisible('menuMV')" :darkMode="true"
							title="Visa produkter som passar din MC" @modelPickerComplete="(() => this.modelPickerComplete())"
							@modelPickerCancel="(() => this.hideAllPageMenu())" />
					</div>
				</div>

				<!-- outlet -->
				<div style="background:var(--grey-bg);min-height:300px; ">
					<div id="start-outlet" name="start-outlet" class="anchor" style="">&nbsp;</div>
					<div class="center center-padding " style="padding-top:50px;padding-bottom:100px;">
						<h3>Outlet</h3>
						<div id="start-outlet-grid" class="" style="margin-top:5px;back">


							<Card v-for="outlet in this.outletList" :key="outlet.productGroupKey" :cardtitle="outlet.title"
								@click="this.outlet(outlet.productTypePT, outlet.productGroupKey)"
								:filename="'group-' + outlet.productGroupKey?.toLowerCase()  + '.png' " :subtitle="outlet.subtitle"
								style="" :tint="true" mode="dark" fontSizeTitleMax="140%" class="card link" />
						</div>
					</div>
				</div>




			</div>
			<div name="start-footer" id="start-footer" class="anchor" style="height:10px;">&nbsp;</div>
			<Footer />

		</div>


	</div>
</template>

<script>

import mcimage from "@/assets/card/mc.jpg"

import { logMixin } from "@/mixins/logMixin.js";
import { pageMixin } from "@/mixins/pageMixin.js";
import { webContentMixin } from "@/mixins/webContentMixin.js";
import { productMixin } from "@/mixins/productMixin.js";
import { categoryMixin } from "@/mixins/categoryMixin.js";

import { tableConfigMixin } from "@/mixins/tableConfigMixin.js";

import { STORE_GETTER } from "@/store/store";


import { PRODUCT_STORE_GETTER } from "@/store/product-store";





import { modelMixin } from "@/mixins/modelMixin";
import { routerMixin } from "@/mixins/routerMixin";
import { productSearchMixin } from "@/mixins/productSearchMixin";

//import SearchResultProductRow from "./SearchResultProductRow.vue";

import SearchPopoverView from "@/views/product/SearchPopoverView.vue";
import SearchProductTextfield from "@/views/product/SearchProductTextfield.vue";
import PopoverModelPicker from "./product/PopoverModelPicker.vue";
import PopoverManufactorView from "./product/PopoverManufactorView.vue";
import PopoverCategoryView from "./product/PopoverCategoryView.vue";
import SlideListWrapper from "../components/slide/SlideListWrapper.vue";
import ProductTypeView from "./product/ProductTypeView.vue";
import { STORE_ACTION, STORE_COMMIT } from "../store/store";
import Card from "../components/Card.vue";
import WebContent from "../components/WebContent.vue";
import Footer from "../components/Footer.vue";
import StartViewSpinner from "./StartViewSpinner.vue";
import StartModelPicker from "./StartModelPicker.vue";

export default {
	name: "StartView",
	components: {
		SearchPopoverView, SearchProductTextfield, PopoverModelPicker, PopoverManufactorView, PopoverCategoryView, SlideListWrapper,
		ProductTypeView, Card, WebContent, Footer, StartViewSpinner, StartModelPicker
	},
	mixins: [logMixin, pageMixin, tableConfigMixin, productMixin, modelMixin, productSearchMixin, routerMixin, categoryMixin, webContentMixin],
	props:{
		productTypeKey: String
	},
	data() {
		return {
			
			layout: "GRID",
			//result: null,
			filterInput: "",
			spinning: false,
			autoSearch: true,
			currentScrollFromTop: 0,
			currentScrollDirectionChangePosition: 0,
			currentScrollDirection: "DOWN",
			currentScrollY: 0,
			scrollUpStart: 0,
			scrollDownStart: 0,
			trackScrollingOn: "resultList",
			tableConfigKey: "searchProductList",
			showPageHeader: true,
			sortPopover: false,

			/*menuList: [{
				name: "menuSearch",
				visible: false
			}, {
				name: "menuMV",
				visible: false
			}],*/
			pageMenuList: [{
				name: "menuSearch",
				visible: false,
				urlName: null,
				urlName2: "sok-produkter"
			}, {
				name: "menuMV",
				visible: false,
				urlName: "modell-valjaren"
			}, {
				name: "menuCategory",
				visible: false,
				urlName: null
			}, {
				name: "menuManufactor",
				visible: false,
				urlName: "tillverkare-varumarken"
			}],
			dropdown: {},

			//sort: { "property": "score", "name": "Relevans", "desc": false },

			/*sortList: [
				{ property: "score", name: "Bästa träff", desc: true },
				{ property: "name", name: "Benämning, A-Ö", desc: false },
				{ property: "name", name: "Benämning, Ö-A", desc: true },
				{ property: "artnr", name: "Artikelnummer, 0-Ö", desc: false },
				{ property: "artnr", name: "Artikelnummer, Ö-0", desc: true },
				{ property: "price2", name: "Pris, fallade", desc: true },
				{ property: "price2", name: "Pris, stigande", desc: false }],*/
			showDebugResult: false,
			popoverList: ["popoverMc", "popoverCategory", "popoverManufactor"],



		};
	},
	watch: {

		// FP: Hantera urlen, productType
		"productTypeSelected": {
			handler(productType){

				//if (productType) {

				//const currentPath = this.$router.currentRoute?.value?.fullPath?.toLowerCase()

				var params = {};

				if (productType) {
					params = { ...this.$router.currentRoute?.value.params, productTypeKey: productType.urlKey }
				} else {
					params = { ...this.$router.currentRoute?.value.params, productTypeKey: null }
				}

				console.log('FP: watcher: productTypeSelected', productType);
				console.log('FP: watcher: productTypeSelected params: ', params);


				this.$router.replace({ name: this.$route.name, params: params });

				//alert("StartView: setProductTypeByKey: " + productTypeKey);

			}
		},


		"pageMenuList": {
			handler() {
				this.hidePopovers('')
			}, deep: true
		},

		/* FP: 2025-12-12 tog bort denna eftersom den stör navigering från popovers
		visiblePageMenu: function(pageMenu){

			console.log('FP: visiblePageMenu route: pageMenu', pageMenu);
			console.log('FP: visiblePageMenu route: ', this.$route);

			const name = this.$route.name;
			const params = this.$route.params;


			if (pageMenu && pageMenu.urlName){

				this.$router.replace({ name: name, params: params, query: { spm: pageMenu.urlName } })
			}else{
				this.$router.replace({ name: name, params: params, query: {  } })
			}
		},*/
		
		

		filterInput: function (newFilter, oldFilter) {

			console.log('FP: watch: filterInput: ');

			return this.filterInputChanged(newFilter, oldFilter)
			
		}
	},
	computed: {

		getMcImage(){
			return mcimage;
		},

		title() {
			return "ProductsView, layout: " + this.layout;
		},

		
		requestCount() {
			return this.$store.getters[STORE_GETTER.REQUEST_COUNT]
			//return this.$store.state.productStore.data.requestCount
		},

		productTypeModel(){
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL]
		},

		productTypeSelected(){
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED]

		},


		
		baseMcTree() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcTree) {
				return baseModel.mcTree
			}

			return null;

		},

		// FP: Visar den menyn som är öppen om någon är öppen
		visiblePageMenu() {

			const visibleMenu = this.pageMenuList.find(pageMenu => pageMenu.visible)

			if (visibleMenu) {
				return visibleMenu
			}

			return null;


		},

		outletList(){

			
			var list = [];

			const outletProductGroupList = this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_GROUP_LIST]?.filter(productGroup => {
				if (productGroup.key == 'OUTLET_MC' || productGroup.key == 'OUTLET_CYKEL'){
					return true;
				}
			});


			if (outletProductGroupList){

				const productTypeList = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL]?.list;

				outletProductGroupList.forEach(productGroup => {

					const productType = productTypeList?.find(productType => productType.pt == productGroup.pt);

					if (productType && productType.pt){
						list.push({
							title: productGroup.name, subtitle: parseInt(productGroup.productIdList?.length) + " produkter", productGroupKey: productGroup.key, productTypePT: productType.urlKey
						})
					}

					

					

				})
				
			}

			/*const outletCykel = this.$store.getters[STORE_GETTER.PRODUCT_GROUP_LIST]?.find(productGroup => productGroup.key == 'OUTLET_CYKEL');

			if (outletCykel) {
				list.push({ title: "Outlet Cykel", subtitle: "xx antal produkter", productGroupKey: "OUTLET_CYKEL", productTypeKey: "cykel" })
			}*/
				

			return list;

		},
		showStartSpinner(){
			return this.$store.getters[STORE_GETTER.SHOW_START_SPINNER];
		},
		searchProductTextfieldSpinning() {
			//const rebuildingSearchModel = this.$store.getters[STORE_GETTER.REBUILDING_SEARCH_MODEL];
			//return this.spinning || (this.isPageMenuVisible('menuSearch') && rebuildingSearchModel)
			return this.spinning
		},

		imagePathModelPickerCSS() {
			return "url(" + this.imagePathModelPicker + ")";
		},

		imagePathModelPicker() {
			return require("@/assets/card/kolfiber.jpg");
			//return require("@/assets/card/modelpicker.jpg");
		},



		/*startCategoryGrid() {
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]
			const categoryTree = baseModel?.categoryModel?.categoryTree
			var categoryList = categoryTree?.categoryList?.filter(category => category !== null);
			return categoryList
		},*/



	},
	methods: {

		handleEnterPressed(){

			const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];


			if (!productType) { // om ingen kategori är satt. 
				this.$emit("showProductType")
				return;


			} else {
				this.enterPressed();
				this.routerShowProductList();
			}
		},

		categorySelected(category) { // sätter alltid productType eftersom alla categorierna visas. 


			//const productTypeUrlKey = this.getProductTypeUrlKeyFromCategory(category);
			//alert(productTypeUrlKey);

			//const productType = this.productTypeModel?.list?.find(productType => productType.urlKey == productTypeUrlKey)
			//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)

			this.searchCategorySelected(category);
		
			console.log('FP: productTypeModel: ', this.productTypeModel);
			this.showProductList();
			
			
			//this.$router.push("/" + productType.urlKey + "/products");

			//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)

			//alert(productType.key);

			

			//const productTypeUrlKey = this.getProductTypeUrlKeyFromCategory(category);

			//this.routerShowProductListForUrlKey(productTypeUrlKey);
			
		},

		
		searchCategorySelectedLocal(category) {

				this.searchCategorySelectedWithoutNavigation(category);
				const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];

				
				if (!productType) { // om ingen kategori är satt. 
					const productTypeUrlKey = this.getProductTypeUrlKeyFromCategory(category);
					this.routerShowProductListForUrlKey(productTypeUrlKey);


				} else {
					this.routerShowProductList()
				}


		},

		searchManufactorSelectedLocal(manufactor){

			this.searchManufactorSelectedWithoutNavigation(manufactor);

			const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];

			if (!productType) { // om ingen kategori är satt. 
				const productTypeModel = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];

				console.log('FP: productTypeModel: ', productTypeModel);
				console.log('FP: manufactor: ', manufactor);
				
				const productType = productTypeModel.list?.find(productType => productType.pt == manufactor.pt)
				this.routerShowProductListForUrlKey(productType.urlKey);


			} else {
				this.routerShowProductList()
			}

		},

		outlet(productTypeKey, productGroupKey){

			
			const productGroupList = this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_GROUP_LIST];

			const searchProductConfig = this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];

			searchProductConfig.productGroupKey = productGroupKey

			this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)

			console.log('FP: productGroupList: ', productGroupList);
			


			

			// välj produktGrupp
			//const productTypeModel = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];
			//const productType = productTypeModel.list?.find(productType => productType.urlKey == productTypeKey)

			//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE_BY_URL_KEY, productTypeKey)

			//alert(productType.urlKey);

			this.routerShowProductListForUrlKey(productTypeKey);

			//this.$router.push("/" + productTypeKey + "/products");


			

		},
		
		showSideMenuCategory(){
			this.$store.commit(STORE_COMMIT.SET_SIDE_MENU_KEY, "category")
			this.$emit('sideMenuVisible', true)
		},
		test(){

			const query = this.$route.query;
			const name = this.$route.name;

			console.log('FP: route: query: ', query);
			
			this.$router.replace({ name: name, query: { show: 'category' } })
			
		},


		showProductDetails(product) {
			this.routerShowProductDetails(product)
		},

		isSortSelected(sort) {
			return this.searchProductConfig?.sort?.property == sort.property && this.searchProductConfig?.sort?.desc == sort.desc
		},

		yearSelectedMV() {
			if (this.searchProductConfig.brand == null) {
				//alert("brand");
				return;
			}

			if (this.searchProductConfig.mc == null) {
				alert("mc");
				return;
			}


			this.hideAllPageMenu()

		},

		resetScrollLimit(){
			//alert("resetScrollLimit")
		},
		


		setupScroll() {
			// FP: TODO fixa denna 
		},

		selectPopoverOpen(popoverName) {
			//alert("selectPopover: " + popoverName);
			this.hidePopovers(popoverName);

		},



		hidePopovers(skipPopoverName) {

			//alert("Skip: " + skipPopoverName);

			this.popoverList.forEach(popoverName => {

				if (this.$refs[popoverName]) {
					console.log('FP: refs: popover: ', this.$refs[popoverName]);
					if (skipPopoverName != popoverName) {
						this.$refs[popoverName].closePopover();
						//alert("close: " + popoverName)
					}


				}

			});

			

		},

		modelPickerComplete(){
			this.hideAllPageMenu();
			this.routerShowProductListForUrlKey("mc");
		},

/*		testXX() {
			this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });
		},

*/


		getProductRowListComplete() {
			this.triggerSearch();
		},

		showProductList(){
			//this.$router.push("/products");
			this.routerShowProductList();
		},



	

	},

	

	created() {
		//document.getElementById(this.trackScrollingOn).addEventListener("scroll", this.trackScrolling);
		//document.addEventListener("scroll", this.trackScrollingDocument);

		// hantera urlen

		/*
		if (this.productTypeKey){
			const productType = this.productTypeModel?.list?.find(productType => productType.urlKey == this.productTypeKey?.toLowerCase());

			if (productType) {
				//alert("$route.params.productTypeKey: " + productType.key)
				this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)

			}
		}*/
		this.routerSetupStartUrl();
		

		//if (this.productId == null){
		//this.productId = productId
		//this.getProductDetails({ productId: this.productId });
		//}

		if (this.tableConfig && this.tableConfig.filter) {
			this.filterInput = this.tableConfig.filter
		}

		this.getBaseModel();
		

		if (this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST]?.length < 100) {
			this.getProductRowList();
		}

		// återställer sökfilter
		this.resetSearchProductConfig();
		this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, this.searchProductConfig)
		// FP: CP2: this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL); // bygger om sökmodellen (vilka produkter som ska ingå i modellen. 
		this.$store.dispatch({ type: STORE_ACTION.REBUILD_SEARCH_MODEL_ACTION }).then(() => {

			const searchModel = this.$store.getters[STORE_GETTER.SEARCH_MODEL];

			this.$store.dispatch({ type: STORE_ACTION.SEARCH_PRODUCT_A, data: { productList: searchModel.productList } }).then(result => {
				console.log('FP: result: ', result);

				this.$store.commit(STORE_COMMIT.CREATE_MODEL);
				//alert("search done");
				console.log('FP: startView search done');



			})

			// hantera vilka om någon meny ska öppnas via urlen. 
			const pageMenuUrlName = this.$route.query.spm

			if (pageMenuUrlName) {
				const pageMenu = this.pageMenuList.find(pageMenu => pageMenu.urlName == pageMenuUrlName);
				if (pageMenu) {
					console.log('FP: route startView visar menu: ', pageMenu.name);

					this.showPageMenu(pageMenu.name);
				}
			}

		})


		//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType);




		//this.enterPressed()


	},

	unmounted() {
		
		//const element = document.getElementById(this.trackScrollingOn);

		//if (element) {
		//element.removeEventListener("scroll", this.trackScrolling);
		//document.removeEventListener("scroll", this.trackScrollingDocument);
		//}
	},
};
</script>



<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap');

div#footer.center h1{
	font-family: "Mulish", sans-serif;
		font-optical-sizing: auto;
		font-weight: 300;
		font-style: normal;
		color: white;
}


html body div#app div div div div.content div.page div.page-header div.page-header-menu-hide,
html body div#app div div div div.content div.page div.page-header div.page-header-menu-show {
	/*background: red;*/
	height: 100px;
	/* 120 */
	/* 160 */
}


html body div#app div div div div.content div.page div.page-header div.page-menu {
	/* top: calc(var(--top-header-height-logout) + 35px); */
	/* 120 */
	/* har ett lägre värde för att dölja kategori */
	z-index: 20;
	border-bottom: 10px solid transparent;
	border-color: orange;
	border-color: white;
}

html body div#app div.site.login div.content div.page div.page-header div.page-menu {
	top: calc(var(--top-header-height-login) + 35px);
	background:red; 
	background: white;
}

html body div#app div.site.logout div.content div.page div.page-header div.page-menu {
	top: calc(var(--top-header-height-logout) + 35px);
	background: white;
}

html body div#app div.site.login div.content div.page div.page-header div.page-menu.search-popover {
	top: calc(var(--top-header-height-login) + 100px);
	background: pink;
	background: white;
	
}

html body div#app div.site.logout div.content div.page div.page-header div.page-menu.search-popover {
	top: calc(var(--top-header-height-logout) + 100px);
	background: yellow;
	background: white;

}

div#startCategoryGrid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(min(100%/5, max(350px, 100%/7)), 1fr));
	grid-row: auto;
	column-gap: 10px;
	row-gap: 5px;
	border: 5px solid transparent;
	align-items: stretch;

}

div#startCategoryGrid div.card {
	min-width: 200px;
	max-height: 250px;
	min-height: 300px;
	max-width: 350px;
}

@media (max-width: 1068px) {

	div#startCategoryGrid {
		display: grid;
		grid-template-columns: auto auto auto;
	}

	div#startCategoryGrid div.card {
		min-height: 250px;
	}

}

@media (max-width: 768px) {

	div#startCategoryGrid {
		display: grid;
		grid-template-columns: auto auto;
		
	}

	div#startCategoryGrid div.card {
		min-height: 200px;
		max-width: 100px;
		border:0px solid red;
		max-height: 250px;
		min-height: 200px;
		min-width: 150px;
		max-width: 100%;

	}

}

html body div#app div.site.logout div.anchor{
	margin-top: -140px;
	position: absolute;
	display: block;
}

html body div#app div.site.login div.anchor {
	margin-top: -200px;
	position: absolute;
		display: block;
}

div#start-outlet-grid {
	display:flex;
	gap:10px;
	height:300px;

}

div#start-outlet-grid div#card {
	flex: 0 1 300px;
		/* grow 0, shrink 1, basis 250px */
		max-width: 300px;
	
}

@media (max-width: 768px) {

	div#start-outlet-grid{

		height: 250px;
	}

}

div#modelpicker{
	
		/*background-image: url("img/category_4.jpg");*/
		background-image: v-bind(imagePathModelPickerCSS);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center top;
	
		/* valfritt */
		background-color: #000;

		min-height: 300px;
		/*background-image: linear-gradient(rgb(50, 49, 49), black);*/
}



</style>
